import { render, staticRenderFns } from "./ImportMessageCard.vue?vue&type=template&id=eb64aab8&"
import script from "./ImportMessageCard.vue?vue&type=script&lang=js&"
export * from "./ImportMessageCard.vue?vue&type=script&lang=js&"
import style0 from "./ImportMessageCard.vue?vue&type=style&index=0&id=eb64aab8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports